export function privacyInit() {
    function setCookie(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + days * 864e5);
        document.cookie = name + "=" + encodeURIComponent(value)
            + ";expires=" + d.toUTCString()
            + ";path=/;SameSite=Lax";
    }
    function getCookie(name) {
        const pair = document.cookie.split("; ").find(row => row.startsWith(name + "="));
        return pair ? decodeURIComponent(pair.split("=")[1]) : null;
    }

    const consentName = "cookie_consent";
    const banner = document.getElementById("cookie-banner");
    const btn = document.getElementById("cookie-accept");

    if (!banner) {
        console.warn('Cookie banner element with id "cookie-banner" not found.');
        return;
    }

    if (!btn) {
        console.warn('Accept button element with id "cookie-accept" not found.');
        return;
    }

    if (getCookie(consentName) !== "1") {
        banner.classList.remove('d-none');
    }

    // accept and hide smoothly
    btn.addEventListener("click", function (event) {
        setCookie(consentName, "1", 180); // 180 дней
        banner.classList.add("opacity-0", "translate-y-2");
        banner.addEventListener("transitionend", () => banner.remove(), { once: true });
        event.preventDefault();
    });
};
